import { Button, TextArea } from "@dune/ui";
import React, { useCallback, useEffect, useRef, useState } from "react";

interface EntityDuneCommentProps {
	initialComment: string | null | undefined;
	onSave: (comment: string | null) => void;
	isSaving?: boolean;
}

const EntityDuneComment: React.FC<EntityDuneCommentProps> = ({
	initialComment,
	onSave,
	isSaving = false,
}) => {
	const [comment, setComment] = useState(initialComment ?? "");
	const lastSavedComment = useRef(initialComment ?? "");

	useEffect(() => {
		setComment(initialComment ?? "");
		lastSavedComment.current = initialComment ?? "";
	}, [initialComment]);

	const handleSave = useCallback(() => {
		onSave(comment === "" ? null : comment);
	}, [comment, onSave]);

	const isDirty = comment !== lastSavedComment.current;

	return (
		<div className="flex flex-col gap-1 w-1/4">
			<TextArea
				value={comment}
				onChange={(e) => setComment(e.target.value)}
				placeholder="Ajouter une note interne…"
				className="resize-none min-h-[60px] text-sm bg-amber-50 border-amber-200 focus-visible:ring-amber-300 placeholder:text-amber-400"
				rows={2}
			/>
			<div className="flex justify-end">
				<Button
					size="sm"
					variant="outline"
					onClick={handleSave}
					disabled={!isDirty || isSaving}
					isLoading={isSaving}
					className="text-xs h-7"
				>
					Enregistrer
				</Button>
			</div>
		</div>
	);
};

export default EntityDuneComment;
